export default {
      id: "ic-home-assistance-usage",
      viewBox: "0 0 53.2 51.8",
      url: "../dist/images/" + "sprite.svg#ic-home-assistance-usage",
      toString: function () {
        return this.url;
      }
    }